import * as React from "react";
import { GooglePay } from "./GooglePay.js";
import { mapLineItemsToTransactionInfoItems } from "../../../../../mappers/modules/PaymentMethodsList/Payments/Adyen/GooglePay/mappers/transaction-info-line-items.js";
import { usePaymentsUIContext } from "../../../../../../../../../../context/PaymentsUI/context/PaymentsUI/context.js";
const GooglePayRegularContainer = ({ onClick, onAuthorize }) => {
  const { cartPrices, lineItems, setGooglePayToken } = usePaymentsUIContext();
  const mappedLineItems = mapLineItemsToTransactionInfoItems(lineItems);
  return /* @__PURE__ */ React.createElement(
    GooglePay,
    {
      cartPrices,
      lineItems: mappedLineItems,
      setGooglePayToken,
      onClick,
      onAuthorize
    }
  );
};
export {
  GooglePayRegularContainer
};
//# sourceMappingURL=GooglePayRegularContainer.js.map
